"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MAIN_BODY_IDENTIFIER = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formulaBody = _interopRequireDefault(require("./components/formulaBody"));
var _excessFormula = _interopRequireDefault(require("./components/excessFormula"));
var _minimumUsage = _interopRequireDefault(require("./components/minimumUsage"));
var _customLabel = _interopRequireDefault(require("./components/customLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MAIN_BODY_IDENTIFIER = exports.MAIN_BODY_IDENTIFIER = 'formula';
var Flex = function Flex(props) {
  var disabled = props.disabled,
    rule = props.rule,
    errors = props.errors,
    labels = props.labels,
    getFormulaOperandValues = props.getFormulaOperandValues,
    ruleIndex = props.ruleIndex,
    formulaOperators = props.formulaOperators,
    ruleChange = props.ruleChange,
    formulaOtherProps = props.formulaOtherProps;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-formula-container"
  }, /*#__PURE__*/_react["default"].createElement(_formulaBody["default"], {
    componentIdentifier: MAIN_BODY_IDENTIFIER,
    disabled: disabled,
    errors: errors,
    rule: rule,
    labels: labels,
    formulaOperators: formulaOperators,
    ruleIndex: ruleIndex,
    ruleChange: ruleChange,
    getFormulaOperandValues: getFormulaOperandValues,
    formulaOtherProps: formulaOtherProps
  }), /*#__PURE__*/_react["default"].createElement(_minimumUsage["default"], {
    rule: rule,
    labels: labels,
    errors: errors,
    formulaOperators: formulaOperators,
    disabled: disabled,
    ruleChange: ruleChange,
    ruleIndex: ruleIndex,
    getFormulaOperandValues: getFormulaOperandValues,
    formulaOtherProps: formulaOtherProps
  }), /*#__PURE__*/_react["default"].createElement(_excessFormula["default"], {
    rule: rule,
    labels: labels,
    errors: errors,
    formulaOperators: formulaOperators,
    disabled: disabled,
    ruleChange: ruleChange,
    ruleIndex: ruleIndex,
    getFormulaOperandValues: getFormulaOperandValues,
    formulaOtherProps: formulaOtherProps
  }), /*#__PURE__*/_react["default"].createElement(_customLabel["default"], {
    rule: rule,
    labels: labels,
    errors: errors,
    ruleChange: ruleChange,
    disabled: disabled
  }));
};
Flex.defaultProps = {
  errors: {},
  disabled: false,
  formulaOtherProps: {},
  formulaOperators: []
};
Flex.propTypes = {
  disabled: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number.isRequired,
  errors: _propTypes["default"].shape({}),
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  formulaOtherProps: _propTypes["default"].shape({}),
  rule: _propTypes["default"].shape({}).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  getFormulaOperandValues: _propTypes["default"].func.isRequired,
  actions: _propTypes["default"].shape({
    deleteRuleBlock: _propTypes["default"].func.isRequired
  }).isRequired
};
var _default = exports["default"] = Flex;